<div class="nav-side-menu sidebar hover-d">
  <a href="javascript:void(0);" class="brand-link">
    <span class="logo-img"></span>
    <!-- <img class="brand-image" src="/assets/img/brand/logo-high-original.png" /> -->
    <!-- <img class="brand-minized-image" src="../../../assets/brand/logo-high-dark.jpg" /> --> <!--will use leter-->
  </a>

  <nav class="nav" role="navigation">
    <ul class="nav__list">
      <!-- <li class="">
        <a class="nav-link" routerLinkActive="active" routerLink="/dashboard">
          <span class="left-icon"><i class="fa fa-solid fa-chart-pie"></i></span>
          <span class="menu-name">Dashboard</span>
        </a>
      </li> -->

      <li class="">
        <a class="nav-link" routerLinkActive="active" routerLink="/user-dashboard">
          <!--class="active" (click)="goToPage('/dashboard')"-->
          <span class="left-icon"><i class="fa fa-solid fa-chart-pie"></i></span>
          <span class="menu-name">My Dashboard</span>
        </a>
      </li>

      <li class="">
        <a class="nav-link" routerLinkActive="active" routerLink="/chart">
          <!--class="active" (click)="goToPage('/dashboard')"-->
          <span class="left-icon"><i class="fa fa-solid fa-chart-pie"></i></span>
          <span class="menu-name">Chart</span>
        </a>
      </li>

      <li class="">
        <a class="nav-link" routerLinkActive="active" routerLink="/myTimesheet">
          <!--class="active" (click)="goToPage('/dashboard')"-->
          <span class="left-icon"><i class="fa fa-solid fa-calendar-days"></i></span>
          <span class="menu-name">My Timesheet</span>
        </a>
      </li>

      <li class="">
        <a class="nav-link" routerLinkActive="active" routerLink="/myLeaves">
          <!--class="active" (click)="goToPage('/dashboard')"-->
          <span class="left-icon"><i class="fa fa-solid fa-calendar-day"></i></span>
          <span class="menu-name">My Leaves</span>
        </a>
      </li>

      <li class="" *ngIf="isAdministrator()">
        <a class="nav-link" routerLinkActive="active" routerLink="/approveLeaves">
          <!--class="active" (click)="goToPage('/dashboard')"-->
          <span class="left-icon"><i class="fa fa-solid fa-bell"></i></span>
          <span class="menu-name">Approve Leave Requests</span>
        </a>
      </li>

      <!---Master Menu-->
      <li class="sub-menu-li" *ngIf="!isOnlyTeamMember()"> <!--*ngIf="!isOnlyTeamMember()"-->
        <input id="group-1" type="checkbox" hidden />
        <label class="nav-group" for="group-1">
          <span class="left-icon"><i class="fa fas nav-icon fa-desktop"></i></span>
          <span class="menu-name">Masters</span> <span class="right-arrow fa fa-angle-right"></span>
        </label>
        <ul class="group-list">
          <li *ngIf="!isOnlyTeamMember()"> <!--*ngIf="!isOnlyTeamMember()"-->
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/project-list">
              <!--routerLink="/master/project-list" -->
              <span class="left-icon"><i class="fa fa-solid fa-list"></i></span>
              <span class="menu-name">Manage Projects</span>
            </a>
          </li>
          <li *ngIf="!isOnlyTeamMember()"> <!--*ngIf="!isOnlyTeamMember()"-->
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/manage-project">
              <!--routerLink="/master/project-list" -->
              <span class="left-icon"><i class="fa fa-solid fa-list"></i></span>
              <span class="menu-name">Manage Sub Projects</span>
            </a>
          </li>
          <li *ngIf="isAdministrator()"> <!--*ngIf="isAdministrator()"-->
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/user-list">
              <!--routerLink="/master/user-list" -->
              <span class="left-icon"><i class="fa fa-solid fa-list"></i></span>
              <span class="menu-name">Manage Users</span>
            </a>
          </li>
          <li *ngIf="isAdministrator()">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/holidays">
              <!--routerLink="/master/user-list" -->
              <span class="left-icon"><i class="fa fa-solid fa-mountain-sun"></i></span>
              <span class="menu-name" style="margin-left: 2px;">Manage Holidays</span>
            </a>
          </li>
          <li *ngIf="isAdministrator()"> <!--*ngIf="isAdministrator()"-->
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/manage-issues">
              <!--routerLink="/master/user-list" -->
              <span class="left-icon"><i class="fa fa-solid fa-bug"></i></span>
              <span class="menu-name" style="margin-left: 2px;">Manage Issues</span>
            </a>
          </li>
          <li *ngIf="isAdministrator()"> <!--*ngIf="isAdministrator()"-->
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/manage-actions">
              <!--routerLink="/master/user-list" -->
              <span class="left-icon"><i class="fa fa-solid fa-hexagon-nodes"></i></span>
              <span class="menu-name" style="margin-left: 2px;">Manage Actions</span>
            </a>
          </li>
          <!-- <li>
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/manage-risks">
              <span class="left-icon"><i class="fa fa-regular fa-flag"></i></span>
              <span class="menu-name" style="margin-left: 2px;">Manage Risks</span>
            </a>
          </li> -->
          <li *ngIf="isAdministrator()"> <!--*ngIf="isAdministrator()"-->
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/manage-task">
              <!--routerLink="/master/user-list" -->
              <span class="left-icon"><i class="fa fa-solid fa-list-check"></i></span>
              <span class="menu-name" style="margin-left: 2px;">Manage Workitems</span>
            </a>
          </li>
          <!--second level menu -->
          <li style="display:none;">
            <input id="sub-group-1" type="checkbox" hidden />
            <label for="sub-group-1" class="nav-sub-group"><span class="left-icon"><i
                  class="fa fa-solid fa-wand-magic-sparkles"></i></span>
              <span class="menu-name">Manu Master</span> <span class="right-arrow fa fa-angle-right"></span></label>

            <ul class="sub-group-list">
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/master/scheme-advance-master/member-master-list"><span class="left-icon"><i
                      class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Sub Menu 1</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/master/scheme-advance-master/scheme-master-list"><span class="left-icon"><i
                      class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Sub Menu 2</span></a></li>

              <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                    class="menu-name">2nd level nav item</span></a>
              </li>
              <li>
                <input id="sub-sub-group-1" type="checkbox" hidden />
                <label for="sub-sub-group-1"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span>
                  <span class="menu-name">Third level</span> <span class="right-arrow fa fa-angle-right"></span></label>
                <ul class="sub-sub-group-list">
                  <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                        class="menu-name">3rd level nav item</span></a></li>
                  <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                        class="menu-name">3rd level nav item</span></a></li>
                  <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                        class="menu-name">3rd level nav item</span></a></li>
                </ul>
              </li>
            </ul>
          </li>
          <!-- /second level menu-->

          <!-- <li>
            <a class="nav-sub-link" routerLink="/master/company-master/company-list">
              <span class="left-icon"><i class="fa fa-solid fa-globe"></i></span>
              <span class="menu-name">Company</span>
            </a>
          </li> -->
        </ul>
      </li>
      <!---Master Menu-->


      <!---Report master-->
      <li class="sub-menu-li" *ngIf="!isOnlyTeamMember()"> <!--*ngIf="!isOnlyTeamMember()"-->
        <input id="group-3" type="checkbox" hidden />
        <label class="nav-group" for="group-3" routerLinkActive="active">
          <span class="left-icon"><i class="fa fa-solid fa-book-bookmark"></i></span>
          <span class="menu-name">Reports </span> <span class="right-arrow fa fa-angle-right"></span>
        </label>
        <ul class="group-list">
          <li>
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/reports/project-status-report">
              <span class="left-icon"><i class="fa fa-solid fa-list-check"></i></span>
              <span class="menu-name" style="margin-left: 2px;">Project Status Report</span>
            </a>
          </li>
          <li *ngIf="isAdministrator()">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/reports/revenue-report">
              <span class="left-icon"><i class="fa fa-solid fa-list-check"></i></span>
              <span class="menu-name" style="margin-left: 2px;">Revenue Report</span>
            </a>
          </li>
        </ul>
      </li>
      <!---Report master-->

      <!---Transaction master-->
      <li class="sub-menu-li" style="display: none;">
        <input id="group-2" type="checkbox" hidden />
        <label class="nav-group" for="group-2" routerLinkActive="active">
          <span class="left-icon"><i class="fa fa-solid fa-money-bill-transfer"></i></span>
          <span class="menu-name">Transactions </span> <span class="right-arrow fa fa-angle-right"></span>
        </label>
        <ul class="group-list">
          <!------second level menu------->
          <li>
            <input id="sub-group-2" type="checkbox" hidden />
            <label for="sub-group-2" class="nav-sub-group"><span class="left-icon"><i
                  class="fa fa-solid fa-sack-dollar"></i></span>
              <span class="menu-name">Purchase</span> <span class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list">
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/purchase-master/create-purchase"><span class="left-icon"><i
                      class="fa fa-solid fa-cart-shopping"></i></span> <span class="menu-name"> Create
                    Purchase</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/purchase-master/purchase-list"><span class="left-icon"><i
                      class="fa fa-solid fa-basket-shopping"></i></span> <span class="menu-name"> Purchase</span></a>
              </li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/purchase-master/create-expenses"><span class="left-icon"><i
                      class="fa fa-solid fa-magnet"></i></span> <span class="menu-name"> Create Expenses</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/purchase-master/expense-list"><span class="left-icon"><i
                      class="fa fa-solid fa-bag-shopping"></i></span> <span class="menu-name"> Expenses</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/purchase-master/on-approval"><span class="left-icon"><i
                      class="fa fa-regular fa-thumbs-up"></i></span> <span class="menu-name"> On Approval</span></a>
              </li>

              <!-- <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                        class="menu-name">2nd level nav item</span></a>
                  </li>
                  <li>
                    <input id="sub-sub-group-1" type="checkbox" hidden />
                    <label for="sub-sub-group-1"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span>
                      <span class="menu-name">Third level</span> <span class="right-arrow fa fa-angle-right"></span></label>
                    <ul class="sub-sub-group-list">
                      <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                            class="menu-name">3rd level nav item</span></a></li>
                      <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                            class="menu-name">3rd level nav item</span></a></li>
                      <li><a href="#"><span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span
                            class="menu-name">3rd level nav item</span></a></li>
                    </ul>
                  </li> -->
            </ul>
          </li>
          <!------second level menu------->
          <li>
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/transaction-master/debit-master/debit-list">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Debit Note</span>
            </a>
          </li>
          <li>
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/transaction-master/day-end-stocks">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Day end stock entry</span>
            </a>
          </li>
          <li>
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/transaction-master/verify-day-end-stocks">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">verify day end stock</span>
            </a>
          </li>
          <li>
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/credit-note-master/credit-note-list">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Credit Note</span>
            </a>
          </li>
          <li>
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/journal-voucher-master/journal-voucher-list">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Journal Vouchers</span>
            </a>
          </li>
          <li>
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/customer-order-entry-master/customer-order-entry-list">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Customer Order Entry</span>
            </a>
          </li>
          <li>
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/transaction-master/customer-inward">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Customer Inward</span>
            </a>
          </li>
          <li>
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/payment-master/payment-list">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Payments</span>
            </a>
          </li>
          <li>
            <a class="nav-sub-link" routerLinkActive="active"
              routerLink="/transaction-master/receipt-master/receipt-list">
              <span class="left-icon"><i class="fa-solid fa-list"></i></span>
              <span class="menu-name">Receipts</span>
            </a>
          </li>
          <!------second level menu------->
          <li>
            <input id="sub-group-3" type="checkbox" hidden />
            <label for="sub-group-3" class="nav-sub-group"><span class="left-icon"><i
                  class="fa fa-solid fa-wand-magic-sparkles"></i></span>
              <span class="menu-name">Karagir</span> <span class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list">
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/karagir-master/inward-list"><span class="left-icon"><i
                      class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Inward</span></a></li>
              <li><a routerLinkActive="active" routerLink="/transaction-master/karagir-master/outward-list"><span
                    class="left-icon"><i class="fa fa-solid fa-gear"></i></span> <span
                    class="menu-name">Outward</span></a></li>
            </ul>
          </li>
          <li>
            <input id="sub-group-4" type="checkbox" hidden />
            <label for="sub-group-4" class="nav-sub-group"><span class="left-icon"><i
                  class="fa fa-solid fa-wand-magic-sparkles"></i></span>
              <span class="menu-name">Sales</span> <span class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list">
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/sales-master/generate-mod-slip"><span class="left-icon"><i
                      class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Generate Mod Slip</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/sales-master/generate-token"><span class="left-icon"><i
                      class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Generate Token</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/sales-master/sales-counter"><span class="left-icon"><i
                      class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Sales Counter</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/sales-master/generate-invoice"><span class="left-icon"><i
                      class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Generate Invoice</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/sales-master/invoice-list"><span class="left-icon"><i
                      class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Invoice List</span></a></li>
            </ul>
          </li>
          <li>
            <input id="sub-group-5" type="checkbox" hidden />
            <label for="sub-group-5" class="nav-sub-group"><span class="left-icon"><i
                  class="fa fa-solid fa-wand-magic-sparkles"></i></span>
              <span class="menu-name">Labelling</span> <span class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list">
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/labelling-master/item-inward-details"><span class="left-icon"><i
                      class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Item Inward Details</span></a>
              </li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/transaction-master/labelling-master/item-inward-labels"><span class="left-icon"><i
                      class="fa fa-solid fa-gear"></i></span> <span class="menu-name">Item Inward Labels</span></a></li>
            </ul>
          </li>
          <!------second level menu---------->
        </ul>
      </li>
      <!---Transaction master-->

      <!---Utility master-->
      <li class="sub-menu-li" style="display:none;">
        <input id="group-4" type="checkbox" hidden />
        <label class="nav-group" for="group-4" routerLinkActive="active">
          <span class="left-icon"><i class="fa fa-solid fa-gears"></i></span>
          <span class="menu-name">Utility </span> <span class="right-arrow fa fa-angle-right"></span>
        </label>
        <ul class="group-list">
          <li>
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/utility-master/fill-rates">
              <span class="left-icon"><i class="fa fa-solid fa-receipt"></i></span>
              <span class="menu-name">Fill Rates</span>
            </a>
          </li>
          <li>
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/utility-master/rate-history">
              <span class="left-icon"><i class="fa fa-solid fa-hand-holding-dollar"></i></span>
              <span class="menu-name">Rate History</span>
            </a>
          </li>
          <!--second level menu  -->
          <li>
            <input id="sub-group-6" type="checkbox" hidden />
            <label for="sub-group-6" class="nav-sub-group"><span class="left-icon"><i
                  class="fa fa-solid fa-gear"></i></span>
              <span class="menu-name">User Maintanance</span> <span
                class="right-arrow fa fa-angle-right"></span></label>
            <ul class="sub-group-list">
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/utility-master/user-maintanance/user-list"><span class="left-icon"><i
                      class="fa fa-regular fa-user"></i></span> <span class="menu-name">User</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/utility-master/user-maintanance/active-user"><span class="left-icon"><i
                      class="fa fa-solid fa-user-shield"></i></span> <span class="menu-name">Active User</span></a></li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/utility-master/user-maintanance/inactive-user"><span class="left-icon"><i
                      class="fa fa-solid fa-user-slash"></i></span> <span class="menu-name">Inactive User</span></a>
              </li>
              <li><a class="nav-link" routerLinkActive="active"
                  routerLink="/utility-master/user-maintanance/locked-user"><span class="left-icon"><i
                      class="fa fa-solid fa-user-lock"></i></span> <span class="menu-name">locked User</span></a></li>
            </ul>
          </li>
        </ul>
      </li>
      <!---Utility master-->

      <!-- <li>
            <a routerLink="/log-sheet">
              <span class="left-icon"><i class="fa fas fa-tachometer-alt"></i></span> <span class="menu-name">Menu 1</span>
            </a>
          </li> -->
    </ul>
  </nav>

  <div class="mini-sidebar">
    <span (click)="togglemini()"></span>
  </div>
</div>